import React from 'react';
import { solutions, solutionsSection } from '../../content/siteContent';
import SectionHead from './SectionHead';
import { ArrowLinkIcon, StrokeIcon } from './Icons';

export default function Solutions() {
  return (
    <section id="solucoes" className="section-wrap">
      <span id="services" className="anchor-alias" aria-hidden="true" />

      <SectionHead tag={solutionsSection.tag} title={solutionsSection.title} subtitle={solutionsSection.subtitle} />

      <div className="solutions-grid">
        {solutions.map((solution) => (
          <div className="solution-card" key={solution.title}>
            <div className="solution-card-header">
              <div className="hex-icon">
                <StrokeIcon name={solution.icon} size={24} />
              </div>
              <span className="section-tag section-tag--inline">{solution.pillar}</span>
            </div>
            <h3 className="solution-card-title">{solution.title}</h3>
            <p className="solution-card-desc">{solution.description}</p>
            <div className="solution-card-footer">
              <a id="SaibaMais" href={solution.link} target="_blank" rel="noopener noreferrer" className="solution-link">
                <span>Saiba Mais</span>
                <ArrowLinkIcon />
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
